import { createAsyncThunk } from '@reduxjs/toolkit'
import WatchingMediaProfileMetric from './watching-media-profile-metric-model'
import {
  delete_watchingMediaProfileMetric,
  load_watchingMediaProfileMetrics,
  store_watchingMediaProfileMetric,
} from './watchingMediaProfileMetric-service'

export const LoadWatchingMediaProfileMetricsAsync = createAsyncThunk<any, any>(
  'composer/load/watchingMediaProfileMetric',
  async (params: { uid: string }) => {
    return await load_watchingMediaProfileMetrics(params)
  },
)

export const CreateWatchingMediaProfileMetricAsync = createAsyncThunk<any, any>(
  'composer/create/watchingMediaProfileMetric',
  async (params: WatchingMediaProfileMetric) => {
    return await store_watchingMediaProfileMetric(params)
  },
)

export const DeleteWatchingMediaProfileMetricAsync = createAsyncThunk<any, any>(
  'composer/delete/watchingMediaProfileMetric',
  async (params) => {
    return await delete_watchingMediaProfileMetric(params)
  },
)
